export default [
	{
		 name: 'Base',
		 dirs: [
			{
				 name: 'Cast_Iron',
				 dirs: [
					{
						 name: 'Bar_Table_Base',
						 dirs: [
							{
								 name: 'TBB18-R.png',
								 info: "Bar height 18\" Round Bottom",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TBB18-RR.png',
								 info: "Bar height 18\" Round Bottom with step ring",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TBB2222-R.png',
								 info: "Bar height 22\" x 22\" Bottom with step ring",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TBB2222.png',
								 info: "Bar height 22\" x 22\" Bottom",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TBB945-B.png',
								 info: "Bar height 4 leg base, Black",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'Others',
						 dirs: [
							{
								 name: 'BAR-RING.png',
								 info: "Bar step ring",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'FTB.png',
								 info: "24\" x 24\" Folding table base",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'Table_Base',
						 dirs: [
							{
								 name: 'TB11-BD.png',
								 info: "Bolt Down Base",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB18R.png',
								 info: "18\" Round Bottom",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB22-R.png',
								 info: "22\" Round Bottom",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB2222.png',
								 info: "22\" x 22\" Base",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB2430.png',
								 info: "24\" x 30\" Base",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB30-R.png',
								 info: "30\" Round Bottom",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB3030.png',
								 info: "30\" x 30\" Base",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB522.png',
								 info: "5\" x 22\" Base",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB945-3.png',
								 info: "19\" x 19\" 3 leg Base",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB945-4.png',
								 info: "18\" x 18\" 4 leg Base",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB945-4G.png',
								 info: "18\" x 18\" 3 leg Base, Gold",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB953-G.png',
								 info: "17\" x 17\" Base, Gold",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB953D-G.png',
								 info: "21\" x 34\" Base, Gold",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
			{
				 name: 'Stainless_Steel',
				 dirs: [
					{
						 name: 'Bar_Table_Base',
						 dirs: [
							{
								 name: 'TBB17-S.png',
								 info: "Bar height 18\" round base",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TBB1818-S.png',
								 info: "Bar height 18\" x 18\" square base",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TBB1818-SQ.png',
								 info: "Bar height 18\" x 18\" square base and column",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TBB8-S.png',
								 info: "Bar height bolt down base",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'Others',
						 dirs: [
							{
								 name: 'SD2828.png',
								 info: "28\" x 28\" ",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'Table_Base',
						 dirs: [
							{
								 name: 'TB1625-S.png',
								 info: "16\" x 25\" square base ",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB1625-SQ.png',
								 info: "16\" x 25\" square base and column ",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB17-S.png',
								 info: "18\" round base",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB1818-S.png',
								 info: "18\" x 18\" square base ",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB1818-SQ.png',
								 info: "18\" x 18\" square base and column ",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB22-S.png',
								 info: "22\" round base",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB8-S.png',
								 info: "Bolt down base",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB84-D.png',
								 info: "5\" x 22\"",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'TB84.png',
								 info: "19\" x 19\"",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
		],
	},
	{
		 name: 'Booth',
		 dirs: [
			{
				 name: 'Fast_Food_Set',
				 dirs: [
					{
						 name: 'WFT',
						 dirs: [
							{
								 name: 'WFT002-G.png',
								 info: "2 Seater, Green",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WFT002-R.png',
								 info: "2 Seater, Red",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WFT004-G.png',
								 info: "4 Seater, Green",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WFT004-N.png',
								 info: "4 Seater, Natural",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WFT004-R.png',
								 info: "4 Seater, Red",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
			{
				 name: 'Traditional_Booth',
				 dirs: [
					{
						 name: 'Double',
						 dirs: [
							{
								 name: 'B1-D.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B10-DW.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B13-D.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B13-DW.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B27-D.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B29-D.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B4-D.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B4-W.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B41-D.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B60-D.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'L-Shape',
						 dirs: [
							{
								 name: 'B36.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'Longbench',
						 dirs: [
							{
								 name: 'B14.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B18.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B34.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B40.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B49.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B63.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B65.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'Single',
						 dirs: [
							{
								 name: 'B1-S.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B1-SW.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B10-S.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B10-SW.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B11-S.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B13-S.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B2-S.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B21-S.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B23-S.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B24-S.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B25-S.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B28-SW.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B3-S.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B4-S.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B5-S.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B50-S.png',
								 info: null,
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B57-S.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B58-S.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B80-S.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'Special',
						 dirs: [
							{
								 name: 'B-3.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B-9.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B3-C.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B38.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B45.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B6.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B67.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'Custom.png',
								 info: "Please call for custom sizing and style",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'U_Shape',
						 dirs: [
							{
								 name: 'B33.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B48.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'B64.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
		],
	},
	{
		 name: 'Cabinet',
		 dirs: [
			{
				 name: 'Cashier_Counter',
				 dirs: [
					{
						 name: 'CT01',
						 dirs: [
							{
								 name: 'CT01.png',
								 info: "Front Desk, Natural",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'CT02',
						 dirs: [
							{
								 name: 'CT02.png',
								 info: "Front Desk, Mahogany",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'CT03',
						 dirs: [
							{
								 name: 'CT03.png',
								 info: "Front Counter",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'CT05',
						 dirs: [
							{
								 name: 'CT05.png',
								 info: "Front Counter",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'CT06',
						 dirs: [
							{
								 name: 'CT06.png',
								 info: "Cashier Counter",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'CT07',
						 dirs: [
							{
								 name: 'CT07.png',
								 info: "Cashier Counter",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
			{
				 name: 'Garbage_Cabinet',
				 dirs: [
					{
						 name: 'GC001',
						 dirs: [
							{
								 name: 'GC001-B.png',
								 info: "Back color",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'GC001-M.png',
								 info: "Mahogany color",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'GC001-N.png',
								 info: "Natural color",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'Z-Inner.png',
								 info: "Inner garbage pale",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WS003',
						 dirs: [
							{
								 name: 'WS003-M.png',
								 info: "Mahogany color",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'Z-Inner.png',
								 info: "Inner garbage pale",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
			{
				 name: 'Maitred_D_Stand',
				 dirs: [
					{
						 name: 'MD003',
						 dirs: [
							{
								 name: 'MD003-M.png',
								 info: "Mahogany",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'RL4',
						 dirs: [
							{
								 name: 'RL4.png',
								 info: "Mahogany",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'RL8',
						 dirs: [
							{
								 name: 'RL8.png',
								 info: "Mahogany",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'RL810',
						 dirs: [
							{
								 name: 'RL810.png',
								 info: "Mahogany",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'T50',
						 dirs: [
							{
								 name: 'T50.png',
								 info: "Mahogany",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
			{
				 name: 'Waiter_Station',
				 dirs: [
					{
						 name: 'WS001',
						 dirs: [
							{
								 name: 'WS001-B.png',
								 info: "Black color with door",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WS004',
						 dirs: [
							{
								 name: 'WS004-M-ND.png',
								 info: "Mahogany color with no door",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WS004-N.png',
								 info: "Natural color with door",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WS008',
						 dirs: [
							{
								 name: 'WS008-N-WS.png',
								 info: "Natural color with over shelf",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WS008-N.png',
								 info: "Natural color",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WS015',
						 dirs: [
							{
								 name: 'WS015-M-ND.png',
								 info: "Mahogany color with no door",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
		],
	},
	{
		 name: 'Chair',
		 dirs: [
			{
				 name: 'Metal_Barstool',
				 dirs: [
					{
						 name: 'MB11',
						 dirs: [
							{
								 name: 'MB11-N.png',
								 info: "Black metal frame barstool",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MB115',
						 dirs: [
							{
								 name: 'MB115-B.png',
								 info: "Black",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'MB115-R.png',
								 info: "Red",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'MB115-RI.png',
								 info: "With ring",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'MB115-WB.png',
								 info: "With backing",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MB116',
						 dirs: [
							{
								 name: 'MB116.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "clearance" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MB117',
						 dirs: [
							{
								 name: 'MB117.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MB12',
						 dirs: [
							{
								 name: 'MB12-M.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MB125',
						 dirs: [
							{
								 name: 'MB125.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MB13',
						 dirs: [
							{
								 name: 'MB13.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MB15',
						 dirs: [
							{
								 name: 'MB15-N.png',
								 info: null,
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MB20',
						 dirs: [
							{
								 name: 'MB20.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
			{
				 name: 'Metal_Chair',
				 dirs: [
					{
						 name: 'A05',
						 dirs: [
							{
								 name: 'A05-B.png',
								 info: "",
								 seating: null,
								 seat: "Black Vinyl",
								 frame_color: "Silver Vein",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'A05-BU.png',
								 info: "",
								 seating: null,
								 seat: "Burgundy Vinyl",
								 frame_color: "Silver Vein",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'A06',
						 dirs: [
							{
								 name: 'A06-G.png',
								 info: "",
								 seating: null,
								 seat: "Fabric",
								 frame_color: "Gold",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MC006',
						 dirs: [
							{
								 name: 'MC006.png',
								 info: "",
								 seating: null,
								 seat: "Black Vinyl",
								 frame_color: "Black",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MC11',
						 dirs: [
							{
								 name: 'MC11-M.png',
								 info: "Picture is with veneer woodseat",
								 seating: [ "Black", "Burgundy", "Wood Mahogany", "Veneer Wood Mahogany" ],
								 seat: null,
								 frame_color: "Black",
								 back_color: "Mahogany",
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'MC11-N.png',
								 info: "Picture is with standard black cushion",
								 seating: [ "Black", "Burgundy", "Wood Natural", "Veneer Wood Natural" ],
								 seat: null,
								 frame_color: "Black",
								 back_color: "Natural",
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MC116',
						 dirs: [
							{
								 name: 'MC116-M.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MC117',
						 dirs: [
							{
								 name: 'MC117-DB.png',
								 info: "Dark brown",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'MC117-IV.png',
								 info: "Ivory",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MC12',
						 dirs: [
							{
								 name: 'MC12-M.png',
								 info: "Picture is with Red vinyl seat",
								 seating: [ "Black", "Burgundy", "Wood Mahogany", "Veneer Wood Mahogany" ],
								 seat: null,
								 frame_color: "Black",
								 back_color: "Mahogany",
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MC13',
						 dirs: [
							{
								 name: 'MC13-B.png',
								 info: "Picture is with standard black cushion",
								 seating: [ "Black", "Burgundy", "Wood Walnut", "Veneer Wood Walnut" ],
								 seat: null,
								 frame_color: "Black",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'MC13-S.png',
								 info: "Picture is with standard black cushion",
								 seating: [ "Black", "Burgundy", "Wood Walnut", "Veneer Wood Walnut" ],
								 seat: null,
								 frame_color: "Silver",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MC18',
						 dirs: [
							{
								 name: 'MC18-M.png',
								 info: "Picture is with standard black cushion",
								 seating: [ "Black", "Burgundy", "Wood Mahogany", "Veneer Wood Mahogany" ],
								 seat: null,
								 frame_color: "Silver",
								 back_color: "Mahogany",
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MC20',
						 dirs: [
							{
								 name: 'MC20-B.png',
								 info: null,
								 seating: null,
								 seat: null,
								 frame_color: "Black",
								 back_color: "Black",
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MC28',
						 dirs: [
							{
								 name: 'MC28-M.png',
								 info: "Picture is with standard black cushion",
								 seating: [ "Black", "Burgundy", "Wood Mahogany", "Veneer Wood Mahogany" ],
								 seat: null,
								 frame_color: "Black",
								 back_color: "Mahogany",
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MC38',
						 dirs: [
							{
								 name: 'MC38-W.png',
								 info: "Picture is with standard black cushion",
								 seating: [ "Black", "Burgundy", "Wood Walnut", "Veneer Wood Walnut" ],
								 seat: null,
								 frame_color: "Black",
								 back_color: "Walnut",
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MC816',
						 dirs: [
							{
								 name: 'MC816.png',
								 info: null,
								 seating: null,
								 seat: null,
								 frame_color: "Silver",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MC912',
						 dirs: [
							{
								 name: 'MC912.png',
								 info: null,
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'MC916',
						 dirs: [
							{
								 name: 'MC916-R.png',
								 info: null,
								 seating: null,
								 seat: null,
								 frame_color: "Red",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
			{
				 name: 'Outdoor_Chair',
				 dirs: [
					{
						 name: 'AC2424',
						 dirs: [
							{
								 name: 'AC2424.png',
								 info: "24\" X 24\" table with base",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'AC6009',
						 dirs: [
							{
								 name: 'AC6009.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'AC6013',
						 dirs: [
							{
								 name: 'AC6013.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'AC6024',
						 dirs: [
							{
								 name: 'AC6024.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'AC6101',
						 dirs: [
							{
								 name: 'AC6101.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'AT24',
						 dirs: [
							{
								 name: 'AT24.png',
								 info: "24\" round table with base",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'BC6103',
						 dirs: [
							{
								 name: 'BC6103.png',
								 info: "Bar height",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'BC8000',
						 dirs: [
							{
								 name: 'BC8000.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
			{
				 name: 'Plastic_Chair',
				 dirs: [
					{
						 name: 'XD180',
						 dirs: [
							{
								 name: 'XD180.png',
								 info: "For indoor and outdoor use",
								 seating: null,
								 seat: null,
								 frame_color: "Blue",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "plastic chair" ],
								 angles: [ "XD180_V" ],
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'XD181',
						 dirs: [
							{
								 name: 'XD181.png',
								 info: "for indoor and outdoor use",
								 seating: null,
								 seat: null,
								 frame_color: "Red",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "plastic chair" ],
								 angles: [ "XD180_V" ],
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'XD200',
						 dirs: [
							{
								 name: 'XD200.png',
								 info: "For indoor and outdoor use",
								 seating: null,
								 seat: null,
								 frame_color: "White",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "plastic chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'XD201',
						 dirs: [
							{
								 name: 'XD201-B.png',
								 info: "For indoor and outdoor use",
								 seating: null,
								 seat: null,
								 frame_color: "Black",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "plastic chair" ],
								 angles: [ "XD201_EXP1" ],
								 size: null,
								 edge: null,
							},
							{
								 name: 'XD201-BR.png',
								 info: "For indoor and outdoor use",
								 seating: null,
								 seat: null,
								 frame_color: "Brown",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "plastic chair" ],
								 angles: [ "XD201_EXP1" ],
								 size: null,
								 edge: null,
							},
							{
								 name: 'XD201-BU.png',
								 info: "For indoor and outdoor use",
								 seating: null,
								 seat: null,
								 frame_color: "Blue",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "plastic chair" ],
								 angles: [ "XD201_EXP1" ],
								 size: null,
								 edge: null,
							},
							{
								 name: 'XD201-G.png',
								 info: "For indoor and outdoor use",
								 seating: null,
								 seat: null,
								 frame_color: "Grey",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "plastic chair" ],
								 angles: [ "XD201_EXP1" ],
								 size: null,
								 edge: null,
							},
							{
								 name: 'XD201-GN.png',
								 info: "For indoor and outdoor use",
								 seating: null,
								 seat: null,
								 frame_color: "Green",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "plastic chair" ],
								 angles: [ "XD201_EXP1" ],
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'XD305',
						 dirs: [
							{
								 name: 'XD305.png',
								 info: "For indoor and outdoor use",
								 seating: null,
								 seat: null,
								 frame_color: "Black",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "plastic chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
			{
				 name: 'Wooden_Barstool',
				 dirs: [
					{
						 name: 'PB1515',
						 dirs: [
							{
								 name: 'PB1515.png',
								 info: "",
								 seating: null,
								 seat: "Wood Chair",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "wooden barstool", "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WB101',
						 dirs: [
							{
								 name: 'WB101-M.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Mahogany" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Mahogany",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image with burgundy cushion",
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WB101-N.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Natural" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Natural",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WB101-W.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Walnut" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image with custom color cushion",
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WB102',
						 dirs: [
							{
								 name: 'WB102-C.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Cherry" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Cherry",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image with burgundy cushion",
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WB102-M.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Mahogany" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Mahogany",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image with burgundy cushion",
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WB102-N.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Natural" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Natural",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image with custom color cushion",
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WB102-W.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Walnut" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image with walnut woodseat",
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WB103',
						 dirs: [
							{
								 name: 'WB103-M.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Mahogany" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Mahogany",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WB103-N.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Natural" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Natural",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image with burgundy cushion",
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WB103-W.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Walnut" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WB104',
						 dirs: [
							{
								 name: 'WB104-M.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Mahogany" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Mahogany",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image with burgundy cushion",
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WB104-W.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Walnut" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WB106',
						 dirs: [
							{
								 name: 'WB106-M.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Mahogany" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Mahogany",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image with burgundy cushion",
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WB114',
						 dirs: [
							{
								 name: 'WB114-M.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Mahogany" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Black",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image with burgundy cushion",
								 tags: [ "barstool", "wood barstool", "clearance" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WB118',
						 dirs: [
							{
								 name: 'WB118-M.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Mahogany" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Mahogany",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WB121',
						 dirs: [
							{
								 name: 'WB121-M.png',
								 info: "Call for pad seat options",
								 seating: null,
								 seat: "Wood Seat",
								 frame_color: "Mahogany",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WB121-W.png',
								 info: "Call for pad seat options",
								 seating: null,
								 seat: "Wood Seat",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WB123',
						 dirs: [
							{
								 name: 'WB123-W.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Walnut" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with custom color cushion",
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WB230',
						 dirs: [
							{
								 name: 'WB230-M.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Mahogany" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Mahogany",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with burgundy cushion",
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WB241',
						 dirs: [
							{
								 name: 'WB241.png',
								 info: "Call for custom color options",
								 seating: null,
								 seat: null,
								 frame_color: "Mahogany",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with custom color cushion",
								 tags: [ "barstool", "wood barstool" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
			{
				 name: 'Wooden_Chair',
				 dirs: [
					{
						 name: 'CY09',
						 dirs: [
							{
								 name: 'CY09.png',
								 info: "Call for pad seat options",
								 seating: null,
								 seat: "Wood Seat",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "wooden chair", "chair", "wood chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'CY29',
						 dirs: [
							{
								 name: 'CY29.png',
								 info: "Call for pad seat options",
								 seating: null,
								 seat: "Wood Seat",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "wooden chair", "chair", "wood chair" ],
								 angles: [ "CY29_1" ],
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'CY31',
						 dirs: [
							{
								 name: 'CY31.png',
								 info: "Call for pad seat options",
								 seating: null,
								 seat: "Wood Seat",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "wooden chair", "chair", "wood chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'CY80',
						 dirs: [
							{
								 name: 'CY80.png',
								 info: "Call for pad seat options",
								 seating: null,
								 seat: "Wooden Seat",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "wooden chair", "chair", "wood chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WC101',
						 dirs: [
							{
								 name: 'WC101-M.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Mahogany" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Mahogany",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with burgundy cushion",
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WC101-N.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Natural" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Natural",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with custom color cushion",
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WC101-W.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Walnut" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with custom color cushion",
								 tags: [ "wooden chair", "chair" ],
								 angles: [ "WC101_WWOOD" ],
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WC102',
						 dirs: [
							{
								 name: 'WC102-C.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Cherry" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Cherry",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WC102-M.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Mahogany" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Mahogany",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with burgundy cushion",
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WC102-N.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Natural" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Natural",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WC102-W.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Walnut" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with walnut woodseat",
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WC103',
						 dirs: [
							{
								 name: 'WC103-M.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Mahogany" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Mahogany",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with custom color cushion",
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WC103-N.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Natural" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Natural",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with custom color cushion",
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WC103-W.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Walnut" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WC104',
						 dirs: [
							{
								 name: 'WC104-M.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Mahogany" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Mahogany",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WC104-N.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Walnut" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Natural",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WC104-W.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Walnut" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with custom color cushion",
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WC106',
						 dirs: [
							{
								 name: 'WC106-M.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Walnut" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Mahogany",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with burgundy cushion",
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WC1105',
						 dirs: [
							{
								 name: 'WC1105-W.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "VWood Walnut" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WC114',
						 dirs: [
							{
								 name: 'WC114-B.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Green" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Black",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "clearance", "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WC114-M.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Mahogany" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Black",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with burgundy cushion",
								 tags: [ "clearance", "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WC118',
						 dirs: [
							{
								 name: 'WC118-M.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Mahogany" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Mahogany",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WC123',
						 dirs: [
							{
								 name: 'WC123-W.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Walnut" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with burgundy cushion",
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WC128',
						 dirs: [
							{
								 name: 'WC128-W.png',
								 info: "",
								 seating: null,
								 seat: "Wood Seat",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with woodseat",
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WC128.png',
								 info: "",
								 seating: null,
								 seat: "Special Seat",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with special seat",
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WC221',
						 dirs: [
							{
								 name: 'WC221-C.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Green" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Natural",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with custom color cushion",
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WC230',
						 dirs: [
							{
								 name: 'WC230.png',
								 info: "",
								 seating: [ "Black", "Burgundy", "Wood Mahogany" ],
								 seat: "Standard Black Cushion",
								 frame_color: "Mahogany",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with Mahogany Woodeseat",
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WC241',
						 dirs: [
							{
								 name: 'WC241.png',
								 info: "Call for optional colors",
								 seating: null,
								 seat: null,
								 frame_color: "Mahogany",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with custom color cushion",
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WC388',
						 dirs: [
							{
								 name: 'WC388-W.png',
								 info: "Call for optional seat colors",
								 seating: null,
								 seat: "Black Cushion",
								 frame_color: "Walnut",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with custom color cushion",
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WC939',
						 dirs: [
							{
								 name: 'WC939-C.png',
								 info: "",
								 seating: null,
								 seat: "Special Seat",
								 frame_color: "Cherry",
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: "Image shown with custom color cushion",
								 tags: [ "wooden chair", "chair" ],
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
		],
	},
	{
		 name: 'Other',
		 dirs: [
			{
				 name: 'Ash_Barrel',
				 dirs: [
					{
						 name: 'Ash_Barrel',
						 dirs: [
							{
								 name: 'A25.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'D21.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'RA39.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'RA46.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
			{
				 name: 'Color_Options',
				 dirs: [
					{
						 name: 'Esprit',
						 dirs: [
							{
								 name: 'Esprit.png',
								 info: "Custom colors can be used for booth and chair cushion vinyl. For more choice please call for detail.",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'New_Soho',
						 dirs: [
							{
								 name: 'New_Soho.png',
								 info: "Custom colors can be used for booth and chair cushion vinyl. For more choice please call for detail.",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'Symphony_Classic',
						 dirs: [
							{
								 name: 'Symphony_Classic.png',
								 info: "Custom colors can be used for booth and chair cushion vinyl. For more choice please call for detail.",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
			{
				 name: 'Japanese_Tableware',
				 dirs: [
					{
						 name: 'Lazy_Susan',
						 dirs: [
							{
								 name: 'LD-32.png',
								 info: "32\" Round ",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'SBO28',
						 dirs: [
							{
								 name: 'SBO28.png',
								 info: null,
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'SBR28',
						 dirs: [
							{
								 name: 'SBR28.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'SC28',
						 dirs: [
							{
								 name: 'SC28.png',
								 info: "28\" Round",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
					{
						 name: 'WL-A033',
						 dirs: [
							{
								 name: 'WL-A033.png',
								 info: null,
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
			{
				 name: 'LED_Sign',
				 dirs: [
					{
						 name: 'LED',
						 dirs: [
							{
								 name: 'CH501-22X13.png',
								 info: "22\" x 13\" Open",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'CH703-19X10.png',
								 info: "19\" x 10\" Open",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'HC020-19X10.png',
								 info: "19\" x 10\" Coffee",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'HC021-19X10.png',
								 info: "19\" x 10\" Bar",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'HC028-19X10.png',
								 info: "19\" x 10\" Pizza",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'LS132-22X13.png',
								 info: "22\" x 13\" Open",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
			{
				 name: 'Menu_A-Frame_Board',
				 dirs: [
					{
						 name: 'FMB',
						 dirs: [
							{
								 name: 'FMB-B.png',
								 info: "Black board with chalk",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'FMB-W.png',
								 info: "White board with dry erase",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
			{
				 name: 'Wallpaper',
				 dirs: [
				],
			},
			{
				 name: 'Wooden_Screen',
				 dirs: [
					{
						 name: 'WSC',
						 dirs: [
							{
								 name: 'WSC1683-M.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
							{
								 name: 'WSC1688-M.png',
								 info: "",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: null,
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: null,
								 edge: null,
							},
						],
					},
				],
			},
		],
	},
	{
		 name: 'Table',
		 dirs: [
			{
				 name: 'Laminate',
				 dirs: [
					{
						 name: 'Formica_Laminate',
						 dirs: [
							{
								 name: 'ELT-B.png',
								 info: "Formica Laminate",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Black",
								 thickness: "1 - 1/4 inch",
								 image_info: null,
								 tags: [ "formica laminate", "laminate" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: [ "Black Vinyl", "Aluminium Edge", "Wood Edge", "Chrome Plastic", "Self Edge" ],
							},
							{
								 name: 'ELT-W.png',
								 info: "Formica Laminate",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "White",
								 thickness: "1 - 1/4 inch",
								 image_info: "Comes with White Vinyl to match",
								 tags: [ "formica laminate", "laminate" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: [ "Black Vinyl", "Aluminium Edge", "Wood Edge", "Chrome Plastic", "Self Edge" ],
							},
							{
								 name: 'ELT12.png',
								 info: "Formica Laminate",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Mahogany",
								 thickness: "1 - 1/4 inch",
								 image_info: null,
								 tags: [ "formica laminate", "laminate" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: [ "Black Vinyl", "Aluminium Edge", "Wood Edge", "Chrome Plastic", "Self Edge" ],
							},
							{
								 name: 'ELT13.png',
								 info: "Formica Laminate",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Dark Walnut",
								 thickness: "1 - 1/4 inch",
								 image_info: null,
								 tags: [ "formica laminate", "laminate" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: [ "Black Vinyl", "Aluminium Edge", "Wood Edge", "Chrome Plastic", "Self Edge" ],
							},
							{
								 name: 'ELT15.png',
								 info: "Formica Laminate",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Natural",
								 thickness: "1 - 1/4 inch",
								 image_info: null,
								 tags: [ "formica laminate", "laminate" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: [ "Black Vinyl", "Aluminium Edge", "Wood Edge", "Chrome Plastic", "Self Edge" ],
							},
							{
								 name: 'ELT8086.png',
								 info: "Formica Laminate",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Natural Zebra",
								 thickness: "1 - 1/4 inch",
								 image_info: null,
								 tags: [ "formica laminate", "laminate" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: [ "Black Vinyl", "Aluminium Edge", "Wood Edge", "Chrome Plastic", "Self Edge" ],
							},
							{
								 name: 'ELT8249.png',
								 info: "Formica Laminate",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Dark Zebra",
								 thickness: "1 - 1/4 inch",
								 image_info: "Image with Aluminium Edge",
								 tags: [ "formica laminate", "laminate" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: [ "Black Vinyl", "Aluminium Edge", "Wood Edge", "Chrome Plastic", "Self Edge" ],
							},
						],
					},
					{
						 name: 'Metal_Laminate',
						 dirs: [
							{
								 name: 'MT001.png',
								 info: "Metal Laminate",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: "1 - 1/4 inch",
								 image_info: null,
								 tags: [ "metal laminate", "laminate" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: [ "Aluminium Edge", "Chrome Plastic" ],
							},
							{
								 name: 'MT004.png',
								 info: "Metal Laminate",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: "1 - 1/4 inch",
								 image_info: null,
								 tags: [ "metal laminate", "laminate" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: [ "Aluminium Edge", "Chrome Plastic" ],
							},
							{
								 name: 'MT007.png',
								 info: "Metal Laminate",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: "1 - 1/4 inch",
								 image_info: null,
								 tags: [ "metal laminate", "laminate" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: [ "Aluminium Edge", "Chrome Plastic" ],
							},
							{
								 name: 'MT010.png',
								 info: "Metal Laminate",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: "1 - 1/4 inch",
								 image_info: null,
								 tags: [ "metal laminate", "laminate" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: [ "Aluminium Edge", "Chrome Plastic" ],
							},
							{
								 name: 'MT013.png',
								 info: "Metal Laminate",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: "1 - 1/4 inch",
								 image_info: null,
								 tags: [ "metal laminate", "laminate" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: [ "Aluminium Edge", "Chrome Plastic" ],
							},
							{
								 name: 'MT014.png',
								 info: "Metal Laminate",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: "1 - 1/4 inch",
								 image_info: null,
								 tags: [ "metal laminate", "laminate" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: [ "Aluminium Edge", "Chrome Plastic" ],
							},
							{
								 name: 'MT017.png',
								 info: "Metal Laminate",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: "1 - 1/4 inch",
								 image_info: null,
								 tags: [ "metal laminate", "laminate" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: [ "Aluminium Edge", "Chrome Plastic" ],
							},
							{
								 name: 'MT021.png',
								 info: "Metal Laminate",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: "1 - 1/4 inch",
								 image_info: null,
								 tags: [ "metal laminate", "laminate" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: [ "Aluminium Edge", "Chrome Plastic" ],
							},
							{
								 name: 'MT022.png',
								 info: "Metal Laminate",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: "1 - 1/4 inch",
								 image_info: null,
								 tags: [ "metal laminate", "laminate" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: [ "Aluminium Edge", "Chrome Plastic" ],
							},
							{
								 name: 'MT023.png',
								 info: "Metal Laminate",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: "1 - 1/4 inch",
								 image_info: null,
								 tags: [ "metal laminate", "laminate" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: [ "Aluminium Edge", "Chrome Plastic" ],
							},
						],
					},
				],
			},
			{
				 name: 'Resin',
				 dirs: [
					{
						 name: 'UVCT',
						 dirs: [
							{
								 name: 'UVCT-B.png',
								 info: "Resin Top",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Black",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: [ "24\"x24\"", "24\"x42\"", "24\"R" ],
								 edge: null,
							},
							{
								 name: 'UVCT-R.png',
								 info: "Resin Top",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Red",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: [ "24\"x24\"", "24\"x42\"", "24\"R" ],
								 edge: null,
							},
							{
								 name: 'UVCT-W.png',
								 info: "Resin Top",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "White",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: [ "24\"x24\"", "24\"x42\"", "24\"R" ],
								 edge: null,
							},
							{
								 name: 'UVCT11.png',
								 info: "Resin Top",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "48\"R", "60\"R", "36\"x36\">51\"R" ],
								 edge: null,
							},
							{
								 name: 'UVCT12.png',
								 info: "Resin Top",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "48\"R", "60\"R" ],
								 edge: null,
							},
							{
								 name: 'UVCT13.png',
								 info: "Resin Top",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "24\"R", "48\"R", "60\"R", "36\"x36\">51\"R" ],
								 edge: null,
							},
							{
								 name: 'UVCT20.png',
								 info: "Resin Top",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Mahogany",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "24\"R" ],
								 edge: null,
							},
							{
								 name: 'UVCT30.png',
								 info: "Resin Top",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Walnut",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"" ],
								 edge: null,
							},
							{
								 name: 'UVCT5.png',
								 info: "Resin Top",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: null,
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: null,
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "48\"R", "60\"R" ],
								 edge: null,
							},
						],
					},
				],
			},
			{
				 name: 'Solid_Wood',
				 dirs: [
					{
						 name: 'Beech_Wood',
						 dirs: [
							{
								 name: 'BWT-C.png',
								 info: "Solid Beechwood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Cherry",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'BWT-M.png',
								 info: "Solid Beechwood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Mahogany",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'BWT-N.png',
								 info: "Solid Beechwood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Natural",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'BWT-SPECIAL.png',
								 info: "Solid Beechwood with design",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Any",
								 thickness: "1 - 3/4 inch",
								 image_info: "Image is with Natural color",
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'BWT-W.png',
								 info: "Solid Beechwood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Walnut",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
						],
					},
					{
						 name: 'Oak_Wood',
						 dirs: [
							{
								 name: 'OWT1-BDW.png',
								 info: "Solid Oak Wood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Burned Dark Walnut",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'OWT1-M.png',
								 info: "Solid Oak Wood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Mahogany",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'OWT1-N.png',
								 info: "Solid Oak Wood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Natural",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'OWT1-W.png',
								 info: "Solid Oak Wood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Walnut",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'OWT2-BDW.png',
								 info: "Solid Oak Wood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Burned Dark Walnut",
								 thickness: "2 - 1/4 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'OWT2-BLW.png',
								 info: "Solid Oak Wood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Burned Dark Walnut",
								 thickness: "2 - 1/4 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'OWT2-N.png',
								 info: "Solid Oak Wood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Natural",
								 thickness: "2 - 1/4 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
						],
					},
					{
						 name: 'Pine_Wood',
						 dirs: [
							{
								 name: 'PWT1-DN.png',
								 info: "Solid Pine Wood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Dark Natural",
								 thickness: "1 - 1/2 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'PWT1-DW.png',
								 info: "Solid Pine Wood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Dark Walnut",
								 thickness: "1 - 1/2 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'PWT1-G.png',
								 info: "Solid Pine Wood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Grey",
								 thickness: "1 - 1/2 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'PWT1-LGN.png',
								 info: "Solid Pine Wood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Light Green",
								 thickness: "1 - 1/2 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'PWT1-N.png',
								 info: "Solid Pine Wood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Natural",
								 thickness: "1 - 1/2 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'PWT1-WH.png',
								 info: "Solid Pine Wood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "White",
								 thickness: "1 - 1/2 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'PWT2-DN.png',
								 info: "Solid Pine Wood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Dark Natural",
								 thickness: "2 - 1/4 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'PWT2-DW.png',
								 info: "Solid Pine Wood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Dark Walnut",
								 thickness: "2 - 1/4 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'PWT2-G.png',
								 info: "Solid Pine Wood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Grey",
								 thickness: "2 - 1/4 inch",
								 image_info: null,
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
							{
								 name: 'PWT2-S.png',
								 info: "Solid Pine Wood",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Light Green",
								 thickness: "2 - 1/4 inch",
								 image_info: "Image is with wood edge",
								 tags: [ "solid wood" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "36\"x36\">51\"R", "24\"R", "30\"R", "36\"R", "48\"R", "60\"R", "Custom" ],
								 edge: null,
							},
						],
					},
				],
			},
			{
				 name: 'Veneer',
				 dirs: [
					{
						 name: 'VT',
						 dirs: [
							{
								 name: 'DVT-M.png',
								 info: "Designed Veneer",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Mahogany",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: [ "designed veneer", "veneer" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "48\"R", "60\"R" ],
								 edge: null,
							},
							{
								 name: 'DVT-W.png',
								 info: "Designed Veneer",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Walnut",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: [ "designed veneer", "veneer" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "48\"R", "60\"R" ],
								 edge: null,
							},
							{
								 name: 'VT-M.png',
								 info: "Veneer",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Mahogany",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: [ "veneer" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "48\"R", "60\"R", "36\"x36\">51\"R" ],
								 edge: null,
							},
							{
								 name: 'VT-W.png',
								 info: "Veneer",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Walnut",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: [ "veneer" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "28\"x46\"", "28\"x65\"", "36\"x36\"", "48\"R", "60\"R", "36\"x36\">51\"R" ],
								 edge: null,
							},
							{
								 name: 'VTWE-M.png',
								 info: "Wood Edge Veneer",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Mahogany",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: [ "veneer" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "24\"x48\"", "28\"x46\"", "28\"x65\"", "36\"x36\"" ],
								 edge: null,
							},
							{
								 name: 'VTWE-N.png',
								 info: "Wood Edge Veneer",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Natural",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: [ "veneer" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "24\"x48\"", "28\"x46\"", "28\"x65\"", "36\"x36\"" ],
								 edge: null,
							},
							{
								 name: 'VTWE-W.png',
								 info: "Wood Edge Veneer",
								 seating: null,
								 seat: null,
								 frame_color: null,
								 back_color: null,
								 color: "Walnut",
								 thickness: "1 - 3/4 inch",
								 image_info: null,
								 tags: [ "veneer" ],
								 angles: null,
								 size: [ "24\"x24\"", "24\"x28\"", "24\"x42\"", "24\"x48\"", "28\"x46\"", "28\"x65\"", "36\"x36\"" ],
								 edge: null,
							},
						],
					},
				],
			},
		],
	},

];



// WEBPACK FOOTER //
// ./src/data/directory.js